import { ReactNode, useContext, useMemo } from 'react';
import { UserContext, normalizeUser } from '../../context/UserContext';
import { useInitializeAnalyticsClient } from 'hooks/useInitializeAnalyticsClient';
import { useSentryInitialization } from 'hooks/useSentryInitialization';
import StatsigInitializer from '../../services/statsig/StatsigInitializer';
import { Cookie } from 'utils/cookie';
import Loader from 'components/common/Loader';

type Props = {
  children: ReactNode;
};

export const ServicesInitializer = ({ children }: Props) => {
  const data = useContext(UserContext);

  const user = data?.user;
  const userIsInitialized = data?.userIsInitialized;

  const normalizedUser = normalizeUser(user);
  const atlassianAccountId = normalizedUser.id;

  useSentryInitialization({ loggedInUser: normalizedUser, pathname: window.location.pathname });
  useInitializeAnalyticsClient({ userId: atlassianAccountId });

  const anonymousId = Cookie.readCookie('ajs_anonymous_id') ?? '';

  const identifiers = useMemo(() => {
    return { atlassianAccountId, analyticsAnonymousId: anonymousId };
  }, [atlassianAccountId, anonymousId]);

  if (!userIsInitialized) {
    return <Loader />;
  }

  return <StatsigInitializer identifiers={identifiers}>{children}</StatsigInitializer>;
};
